export default __webpack_public_path__ + "static/media/skull white rose.78713d7a.png";